import { Injectable } from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WardService {

  constructor(private http: HttpClient) { }
  urlEndPoint = environment.endPoint;

  getWards(): Observable<any[]> {
    return this.http.get<any>(this.urlEndPoint + '/api/wards');
  }
  getEntes(ward: any): Observable<any[]> {
    const params = new HttpParams()
      .set('wardId', ward.wardId)
      .set('wardVersion', ward.versionId);
    return this.http.get<any>(this.urlEndPoint + '/api/entes', {params});
  }
}
